export default class extends Controller {

  connect() {
    setTimeout(
      (() => App.TimeEntries.addToAfterTimeLog(this.refreshContent.bind(this))).bind(this),
      500
    )
  }

  disconnect() {
    App.TimeEntries.removeFromAfterTimeLog(this.refreshContent)
  }

  refreshContent() {
    App.Helpers.ajaxRequest({
      url: this.refreshURL,
      successHandler: this.replaceContent.bind(this)
    })
  }

  replaceContent(response) {
    App.Helpers.replaceElement(this.element, response)
  }

  get refreshURL() {
    return this.data.get("refresh-url")
  }
}



// WEBPACK FOOTER //
// ./app/components/day_reviews/assets/javascript/day-reviews-edit-controller.js